<div class="pc-team-toolbar">
  <div class="pc-team-toolbar__summary">
    <h2>Teams</h2>
    <span>{{ listTeams?.length || 0 }} team{{ listTeams?.length === 1 ? '' : 's' }}</span>
  </div>

  <div class="pc-team-toolbar__actions">
    @if (selectedRows.length > 0) {
      <span class="pc-selection-count">{{ selectedRows.length }} selected</span>
      <button mat-stroked-button class="pc-danger-action" (click)="deleteSelectedRowsClick()" [disabled]="deleteTeamsClick">
        <mat-icon>delete</mat-icon>
        Delete selected
      </button>
    }
    <button mat-stroked-button (click)="export()">
      <mat-icon>file_download</mat-icon>
      Export
    </button>
    <button mat-raised-button color="primary" (click)="addTeam()">
      <mat-icon>group_add</mat-icon>
      Add team
    </button>
  </div>
</div>

<div class="pc-pt-wrapper">
  <p-table
    [value]="listTeams || []"
    dataKey="team.uid"
    [(selection)]="selectedRows"
    [loading]="tableLoading"
    [scrollable]="true"
    scrollHeight="calc(100vh - 320px)"
    [paginator]="(listTeams?.length || 0) > 15"
    [rows]="15"
    [rowsPerPageOptions]="[15, 30, 50]"
    [rowHover]="true"
    sortField="team.name"
    [sortOrder]="1"
    styleClass="p-datatable-sm pc-team-table"
    currentPageReportTemplate="{first}–{last} of {totalRecords}"
    [showCurrentPageReport]="true">

    <ng-template pTemplate="header">
      <tr>
        <th class="pc-select-column"><p-tableHeaderCheckbox /></th>
        <th pSortableColumn="team.name">Team <p-sortIcon field="team.name" /></th>
        <th pSortableColumn="memberCount">Members <p-sortIcon field="memberCount" /></th>
        <th class="pc-actions-column"><span class="sr-only">Actions</span></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item>
      <tr>
        <td class="pc-select-column"><p-tableCheckbox [value]="item" /></td>
        <td>
          <div class="pc-team-identity">
            <span class="pc-team-avatar">{{ teamInitials(item.team) }}</span>
            <div>
              <button type="button" class="pc-team-name" (click)="editTeam(item)">{{ item.team.name || 'Untitled team' }}</button>
              @if (item.memberCount === 0) { <span class="pc-team-note">No members yet</span> }
            </div>
          </div>
        </td>
        <td>
          <div class="pc-member-cell">
            @if (item.avatars.length > 0) {
              <span class="pc-member-stack">
                @for (avatar of item.avatars; track avatar.name) {
                  <span class="pc-member-avatar" [title]="avatar.name">{{ avatar.initials }}</span>
                }
                @if (item.overflow > 0) { <span class="pc-member-avatar pc-member-avatar--more">+{{ item.overflow }}</span> }
              </span>
            }
            <span class="pc-member-count">{{ item.memberCount }} member{{ item.memberCount === 1 ? '' : 's' }}</span>
          </div>
        </td>
        <td class="pc-actions-column">
          <button mat-icon-button [matMenuTriggerFor]="rowMenu" aria-label="Actions for this team" (click)="$event.stopPropagation()">
            <mat-icon>more_horiz</mat-icon>
          </button>
          <mat-menu #rowMenu="matMenu">
            <button mat-menu-item (click)="editTeam(item)">
              <mat-icon>edit</mat-icon><span>Edit team</span>
            </button>
            <mat-divider></mat-divider>
            <button mat-menu-item class="pc-danger-action" (click)="deleteSelectedRowsClick(item)" [disabled]="deleteTeamsClick">
              <mat-icon>delete</mat-icon><span>Delete team</span>
            </button>
          </mat-menu>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr><td colspan="4" class="pc-empty">{{ tableLoading ? 'Loading teams…' : 'No teams yet.  Create one to group users together.' }}</td></tr>
    </ng-template>
  </p-table>
</div>
